import axios from "axios";
import config from "../config";

export interface MobPersona {
  id: string;
  name: string;
  gender: "male" | "female" | "other";
  age: number;
  job: string;
  profile: string;
  habits: string;
}

export interface MobPersonaProfileOutput {
  id: string;
  name: string;
  profile: string;
}

export interface MobPersonas {
  mob_personas: MobPersona[];
}

export const listMobPersonas = async (token: string): Promise<MobPersonas> => {
  const response = await axios.get<MobPersonas>(`${config.apiUrl}/mob-personas`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getMobPersonaProfile = async (token: string, mobPersonaId: string): Promise<MobPersonaProfileOutput> => {
  const response = await axios.get<MobPersonaProfileOutput>(`${config.apiUrl}/mob-personas/${mobPersonaId}/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
